import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import HeadingBox from '../../UI/Headings/HeadingBox/HeadingBox';
import HeadingH2 from '../../UI/Headings/HeadingH2/HeadingH2';
import HeadingH3 from '../../UI/Headings/HeadingH3/HeadingH3';
import Button from '../../UI/Button/Button';

import authResetCompletedImage from './img/auth-reset-completed.png';

import * as authActions from '../../../store/actions/index';

class AuthRestCompleted extends Component {

    render() {
        return (
            <React.Fragment>
                <div className={`mb-6 u-textAlignCenter`}>
                    <img src={authResetCompletedImage} alt='Authentication Reset'/>
                </div>
                <div className={`mb-10 u-textAlignCenter u-phoneTextAlignCenter`}>
                    <HeadingBox>
                        <div className="mb-1">
                            <HeadingH2 size={26} weight="Regular" color="Dark">Congratulations!</HeadingH2>
                        </div>
                        <HeadingH3 size={13} weight="Regular" color="Light">Your password associated with Email ID: abhishekjakhar.11@gmail.com has been reset</HeadingH3>
                    </HeadingBox>
                </div>
                <div className={`u-textAlignCenter mb-4`}>
                    <p className={`u-textColorDark`}>Login to your account and start booking.</p>
                </div>
                <div>
                    <Button theme='Primary' width='Block' type='Login' onClick={() => {
                            this.props.onSetAuthView('home');
                            this.props.history.push('/')}
                        }>Proceed to Login</Button>
                </div>
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSetAuthView: (view) => dispatch(authActions.setAuthView(view))
    }
}

export default withRouter(connect(null, mapDispatchToProps)(AuthRestCompleted));


// WEBPACK FOOTER //
// ./src/components/Authentication/AuthResetCompleted/AuthResetCompleted.js